import { EXCLUDED_FETCH_URLS } from './excluded-urls.js'

export function shouldBeDiscardedFromRum (event, context) {
  if (event.type === 'error') {
    const errorMessage = event?.error?.message

    // Closing attachable is done via promise rejection which when unhandled throws errors to console
    // - [attachable] closed with reason: *
    // - [attachable] closed
    if (typeof errorMessage === 'string' && errorMessage?.includes('[attachable] closed')) {
      return true
    }

    // Errors from external scripts
    // Error: Script error.
    // at undefined @
    if (typeof errorMessage === 'string' && errorMessage?.includes('Script error.')) {
      return true
    }

    // External tracking scripts fetch errors
    if (typeof errorMessage === 'string' && errorMessage?.includes('Fetch error')) {
      const isExcludedUrl = EXCLUDED_FETCH_URLS.some(url => errorMessage.includes(url))
      if (isExcludedUrl) {
        return true
      }
    }

    // Type Error: Load failed.
    if (typeof errorMessage === 'string' && errorMessage === 'Load failed') {
      return true
    }

    // Type Error: { "componentRef": null }
    if (typeof errorMessage === 'string' && errorMessage?.includes('componentRef')) {
      return true
    }

    // UnknownError: Connection to Indexed Database server lost. Refresh the page to try again
    if (typeof errorMessage === 'string' && errorMessage === 'Connection to Indexed Database server lost. Refresh the page to try again') {
      return true
    }

    if (typeof errorMessage === 'string' && errorMessage?.includes('handshake failed CANCEL')
      && (event?.view?.referrer?.includes('services/service-edit') || event?.view?.url?.includes('services/service-edit'))) {
      return true
    }
  }

  return false
}
